/**
 * Whether `value` names a timezone a clock can be set to: an IANA zone
 * (including UTC), never a fixed numeric offset or something Intl would
 * silently fall back from.
 */
export function isIanaTimezone(value: string): boolean {
  try {
    if (/^[+-]/.test(value)) return false;
    new Intl.DateTimeFormat('en', { timeZone: value }).format();
    return true;
  } catch {
    return false;
  }
}

/**
 * Whether a write should refuse this timezone. Only a CHANGE is checked: a
 * zone stored before the check existed has to stay saveable, or a company
 * holding one could never edit any other setting on the same form again —
 * the same rule as the currency (`currencyChangeIsRefused`).
 */
export function timezoneChangeIsRefused(
  incoming: string | null | undefined,
  stored: string | null | undefined,
): boolean {
  return incoming !== undefined && incoming !== null && incoming !== stored && !isIanaTimezone(incoming);
}
